
const initialState = {
  isRtl:false,
  mode : "light",
  lang : "fa-IR"
};

export const styleReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ISRTL":
      return {
        ...state,
        isRtl: action.value.val,
      };
    case "SET_LANG":
      return {
        ...state,
        lang: action.value.val,
      };
    case "SET_MODE":
      return {
        ...state,
        mode: action.value.val,
      };
   
    default:
      return state;
  }
};

